import React, { Dispatch, PropsWithChildren, SetStateAction, useCallback } from 'react';

import { Button } from '../../Button/Button';
import { IListItem } from '../Utils/IListItem';
import { IListProps } from '../Utils/IListProps';

type IListFiltersProps<T extends IListItem> = Pick<
  IListProps<T>,
  'buttonSetClassName' | 'filters' | 'buttonSetStyle' | 'staffContext' | 'onSelect'
> & {
  setSelected: Dispatch<SetStateAction<number>>;
  selected: number;
};

const ListFilters = <T extends IListItem>(props: PropsWithChildren<IListFiltersProps<T>>) => {
  const {
    buttonSetClassName,
    buttonSetStyle,
    filters,
    onSelect,
    selected,
    setSelected,
    staffContext
  } = props;

  const setFilter = (newSelected: number) => () => {
    if (onSelect) {
      onSelect(newSelected);
    }

    setSelected(newSelected);
  };

  const getButtonClassName = useCallback(
    (index: number) => `list-filter override ${
      selected === index ? 'list-filter--active' : 'list-filter--inactive'
    } ${staffContext ? 'list-filter--staff' : 'list-filter--player'}
`,
    [staffContext, selected]
  );

  return filters ? (
    <div className={`buttonset ${buttonSetClassName}`} style={buttonSetStyle || {}}>
      {filters.map((filter, index) => (
        <Button
          key={`list-filter-${index}`}
          classes={{ label: 'list-filter__label' }}
          className={getButtonClassName(index)}
          variant={selected === index ? 'contained' : 'outlined'}
          color="primary"
          onClick={setFilter(index)}
        >
          {filter.label}
        </Button>
      ))}
    </div>
  ) : (
    <></>
  );
};

export default ListFilters;
